<template>
  <div class="company-applyment-module" v-loading="loading" element-loading-custom-class="absolute-loading">
    <!-- 状态 -->
    <el-affix
      :class="{ 'applyment-page-header-top': affixed, 'applyment-page-header-shrink': sidebarFold, 'applyment-page-header-unfold': !sidebarFold }"
      @change="handleAffixChange"
      :offset="80"
    >
      <el-card>
        <div class="applyment-page-header">
          <div>
            <div class="status">
              {{ applymentStatusFormat(detail.applymentStatus) }}
              <span v-if="detail.hasRenew" class="fs14">{{ renewStatusFormat(detail.linkedRenewStatus) }}</span>
              <span v-if="detail.laterPay" class="fs12">
                (Credit:
                <template v-if="detail.hasPaid">Paid</template>
                <template v-else>Unpaid / Partially Paid</template>
                )
              </span>
            </div>
            <div class="page-header-heading-left">
              <div class="heading-title">Transaction No.: {{ detail.applymentNo }}</div>
            </div>
            <div class="page-header-heading-content">
              <el-descriptions :column="4" direction="vertical">
                <el-descriptions-item label="Transaction No.">{{ detail.applymentNo }}</el-descriptions-item>
                <el-descriptions-item label="Checker">
                  <user-toggle :userList="userList" :user="detail.checker" ownershipRole="checker" />
                </el-descriptions-item>
                <el-descriptions-item label="Reviewer">
                  <user-toggle :userList="userList" :user="detail.auditor" ownershipRole="auditor" />
                </el-descriptions-item>
                <el-descriptions-item label="Coordinator">
                  <user-toggle :userList="userList" :user="detail.coordinator" ownershipRole="coordinator" />
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
          <div class="page-header-heading-right">
            <div class="opts">
              <!-- 认领日志 -->
              <el-button type="text" icon="el-icon-tickets" @click="openOwnershipHistoryModal">Ownership History</el-button>
              <!-- 状态操作日志 -->
              <el-button type="text" icon="el-icon-tickets" @click="openStatusHistoryModal">Status Track</el-button>
              <!-- 发起退款 - 业务 -->
              <el-button
                v-if="
                  (detail.applymentStatus === 'ILLEGAL' ||
                    detail.applymentStatus === 'AUDIT_FAIL' ||
                    detail.applymentStatus === 'ACRA_REJECTED' ||
                    detail.applymentStatus === 'REFUND_APPLY_DENY' ||
                    detail.applymentStatus === 'REFUND_APPLY_REJECT') &&
                  detail.hasPaid &&
                  isApplymentAuth('company:coordinate')
                "
                type="primary"
                size="medium"
                @click="handleInitiateRefund"
              >
                Apply for Refund
              </el-button>
              <!-- 退款审核 - 初审 -->
              <el-button
                v-if="detail.applymentStatus === 'REFUND_APPLYING' && isApplymentAuth('company:check')"
                type="primary"
                size="medium"
                @click="handleRefundJudge('check')"
              >
                Refund Check
              </el-button>
              <!-- 退款审核 - 复核 -->
              <el-button
                v-if="detail.applymentStatus === 'REFUND_APPLY_AGREED' && isApplymentAuth('company:audit')"
                type="primary"
                size="medium"
                @click="handleRefundJudge('audit')"
              >
                Refund Review
              </el-button>
              <!-- 退款信息补充 - 业务 -->
              <el-button
                v-if="detail.applymentStatus === 'REFUND_HANDING' && isApplymentAuth('company:coordinate')"
                type="primary"
                size="medium"
                @click="handleRefundInfoUpdate"
              >
                Refund Info Update
              </el-button>
              <!-- ACRA申请 - 业务 -->
              <el-button
                v-if="detail.applymentStatus === 'AUDIT_SUCCESS' && isApplymentAuth('company:coordinate')"
                type="primary"
                size="medium"
                @click="handleAcraApply"
              >
                Gov Processing
              </el-button>
              <!-- ACRA反馈 - 业务 -->
              <el-button
                v-if="detail.applymentStatus === 'ACRA_APPLYING' && isApplymentAuth('company:coordinate')"
                type="primary"
                size="medium"
                @click="handleAcraFeedback"
              >
                Gov Feedback
              </el-button>
              <!-- 下补款单 - 业务 -->
              <el-button
                v-if="(detail.applymentStatus === 'ACRA_APPLYING' || detail.applymentStatus === 'REVISING') && isApplymentAuth('company:coordinate')"
                type="primary"
                size="medium"
                @click="handleMakeAmends"
              >
                Make Supplemental
              </el-button>
              <!-- 初审 -->
              <el-button
                v-if="(detail.applymentStatus === 'CHECKING' || detail.applymentStatus === 'REVISE_FINISH') && isApplymentAuth('company:check')"
                type="primary"
                size="medium"
                @click="handleCheckFinish"
              >
                Finish Check
              </el-button>
              <!-- 复核 -->
              <el-button
                v-if="detail.applymentStatus === 'AUDITING' && isApplymentAuth('company:audit')"
                type="primary"
                size="medium"
                @click="handleAuditFinish"
              >
                Finish Review
              </el-button>
              <!-- 驳回 -->
              <el-button
                v-if="
                  (detail.applymentStatus === 'ILLEGAL' ||
                    detail.applymentStatus === 'AUDIT_FAIL' ||
                    detail.applymentStatus === 'ACRA_REJECTED' ||
                    detail.applymentStatus === 'REVISING' ||
                    detail.applymentStatus === 'CORRECTED' ||
                    detail.applymentStatus === 'REFUND_APPLY_DENY' ||
                    detail.applymentStatus === 'REFUND_APPLY_REJECT') &&
                  isApplymentAuth('company:coordinate')
                "
                type="danger"
                size="medium"
                @click="handleReject"
              >
                Reject to Client
              </el-button>
              <!-- 提交修改内容 -->
              <el-button
                v-if="
                  (detail.applymentStatus === 'REVISING' ||
                    detail.applymentStatus === 'REFUND_APPLY_DENY' ||
                    detail.applymentStatus === 'REFUND_APPLY_REJECT' ||
                    detail.applymentStatus === 'CORRECTED') &&
                  isApplymentAuth('company:coordinate')
                "
                type="primary"
                size="medium"
                @click="handleReviseFinish"
              >
                Revision Submit
              </el-button>
              <!-- 申请终止交易 -->
              <el-button
                v-if="
                  detail.applymentStatus !== 'SUSPEND_TRANSACTION_APPLYING' &&
                  detail.applymentStatus !== 'TERMINATED' &&
                  detail.applymentStatus !== 'FORFEITED' &&
                  (detail.businessType === 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType === 'FUND_ADMIN_CUSTOMIZED') &&
                  (isApplymentAuth('company:coordinate') || isApplymentAuth('company:check') || isApplymentAuth('company:audit'))
                "
                type="primary"
                size="medium"
                @click="handleTerminationApply"
              >
                Apply for Termination
              </el-button>
              <!-- 申请终止交易 - 复核 -->
              <el-button
                v-if="
                  detail.applymentStatus === 'SUSPEND_TRANSACTION_APPLYING' &&
                  (detail.businessType === 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType === 'FUND_ADMIN_CUSTOMIZED') &&
                  isApplymentAuth('company:audit')
                "
                type="primary"
                size="medium"
                @click="handleAuditTerminated"
              >
                Termination Review
              </el-button>
              <!-- 废弃申请 - 业务、复核 -->
              <el-button
                v-if="
                  detail.applymentStatus != 'FINISH' &&
                  detail.applymentStatus != 'FORFEITED' &&
                  (isApplymentAuth('company:coordinate') || isApplymentAuth('company:audit'))
                "
                type="danger"
                size="medium"
                @click="handleForfeitApply"
              >
                Forfeit Application
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </el-affix>

    <!-- 步骤条 -->
    <div
      class="steps-bar-wrapper"
      v-if="!(detail.isLaterService && (detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType == 'FUND_ADMIN_CUSTOMIZED'))"
    >
      <el-steps :key="visibleSteps.map(s => s.key).join('-')" direction="vertical" align-center :space="80">
        <el-step v-for="step in visibleSteps" :key="step.key" :status="getStepStatus(step.name)" @click.native="jumpStep(step.name)"></el-step>
      </el-steps>
    </div>

    <!-- Step0: 基础信息 -->
    <div class="step mt50">
      <el-card shadow="hover">
        <base-info ref="baseInfoRef" :detail="detail" />
      </el-card>
    </div>

    <div v-if="!(detail.isLaterService && (detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType == 'FUND_ADMIN_CUSTOMIZED'))">
      <!-- Step1: 公司设立 & 股东信息 -->
      <div class="pt40" :ref="getStepName('companyName')" v-if="getStepName('companyName')"></div>
      <div id="Step1" class="step mt40" v-if="getStepName('companyName')">
        {{ void (Step1 = stepsTree[getStepName("companyName")]) }}
        <step-header :label="getStepName('companyName')">
          <div class="state mr20">
            <!-- 步骤操作日志 -->
            <el-button type="text" icon="el-icon-tickets" class="mr20" @click="openStepsHistoryModal(getStepName('companyName'))">Steps History</el-button>
            <div
              class="border-type"
              :class="{
                'no-pass-button': Step1 && Step1.status == 0,
                'pass-button': Step1 && Step1.status == 1,
                'revised-button': Step1 && Step1.status == 2,
                'no-checking-button': Step1 && Step1.status == 3,
              }"
              v-if="Step1"
            >
              <span class="el-icon-error" v-if="Step1 && Step1.status == 0"></span>
              <span class="el-icon-success" v-if="Step1 && Step1.status == 1"></span>
              <span class="el-icon-warning" v-if="Step1 && Step1.status == 2"></span>
              <span class="el-icon-mouse" v-if="Step1 && Step1.status == 3"></span>
              {{ stepStatusFormat(Step1) }}
            </div>
          </div>
          <div class="opts">
            <el-button type="primary" plain v-if="checkStepVisible(getStepName('companyName'))" @click="openStepModal(getStepName('companyName'))">
              Review
            </el-button>
          </div>
        </step-header>
        <el-card shadow="hover">
          <component :is="stepContentComp('companyName')" :detail="detail" :isNeedNomineeDirector="isNeedNomineeDirector" />
        </el-card>
      </div>

      <!-- Step2: 问卷调查 -->
      <div class="pt40" :ref="getStepName('kycQuestionnaire')" v-if="getStepName('kycQuestionnaire')"></div>
      <div id="Step2" class="step mt40" v-if="detail.questionnaire && getStepName('kycQuestionnaire')">
        {{ void (Step2 = stepsTree[getStepName("kycQuestionnaire")]) }}
        <step-header :label="getStepName('kycQuestionnaire')">
          <div class="state mr20">
            <!-- 步骤操作日志 -->
            <el-button type="text" icon="el-icon-tickets" class="mr20" @click="openStepsHistoryModal(getStepName('kycQuestionnaire'))">
              Steps History
            </el-button>
            <!-- 风险评估 -->
            <el-button
              type="text"
              icon="el-icon-edit-outline"
              class="mr20"
              @click="openRiskAssessmentModal"
              v-if="isApplymentAuth('company:coordinate') || isApplymentAuth('company:check') || isApplymentAuth('company:audit')"
            >
              Risk Assessment
              <span style="color: #02cc90" v-if="detail.isRiskAssessmentFinished === 1 && riskAssessmentObj.suggest == 1">(RA-passed)</span>
              <span style="color: #ff7a37" v-if="detail.isRiskAssessmentFinished === 1 && riskAssessmentObj.suggest == 0">(RA-failed)</span>
            </el-button>
            <div
              class="border-type"
              :class="{
                'no-pass-button': Step2 && Step2.status == 0,
                'pass-button': Step2 && Step2.status == 1,
                'revised-button': Step2 && Step2.status == 2,
                'no-checking-button': Step2 && Step2.status == 3,
              }"
              v-if="Step2"
            >
              <span class="el-icon-error" v-if="Step2 && Step2.status == 0"></span>
              <span class="el-icon-success" v-if="Step2 && Step2.status == 1"></span>
              <span class="el-icon-warning" v-if="Step2 && Step2.status == 2"></span>
              <span class="el-icon-mouse" v-if="Step2 && Step2.status == 3"></span>
              {{ stepStatusFormat(Step2) }}
            </div>
          </div>
          <div class="opts">
            <el-button
              type="primary"
              plain
              v-if="checkStepVisible(getStepName('kycQuestionnaire'))"
              @click="openStepModal(getStepName('kycQuestionnaire'))"
            >
              Review
            </el-button>
          </div>
        </step-header>
        <el-card v-if="detail.questionnaire">
          <component
            :is="stepContentComp('kycQuestionnaire')"
            :detail="detail"
            :nativeRegisteredAddress="nativeRegisteredAddress"
            :isNeedNomineeDirector="isNeedNomineeDirector"
          />
        </el-card>
      </div>

      <!-- Step3: 财务信息 & 额外的信息 -->
      <div class="pt40" :ref="getStepName('companyDetails')" v-if="getStepName('companyDetails')"></div>
      <div id="Step3" class="step mt40" v-if="getStepName('companyDetails')">
        {{ void (Step3 = stepsTree[getStepName("companyDetails")]) }}
        <step-header :label="getStepName('companyDetails')">
          <div class="state mr20">
            <!-- 步骤操作日志 -->
            <el-button type="text" icon="el-icon-tickets" class="mr20" @click="openStepsHistoryModal(getStepName('companyDetails'))">
              Steps History
            </el-button>
            <div
              class="border-type"
              :class="{
                'no-pass-button': Step3 && Step3.status == 0,
                'pass-button': Step3 && Step3.status == 1,
                'revised-button': Step3 && Step3.status == 2,
                'no-checking-button': Step3 && Step3.status == 3,
              }"
              v-if="Step3"
            >
              <span class="el-icon-error" v-if="Step3 && Step3.status == 0"></span>
              <span class="el-icon-success" v-if="Step3 && Step3.status == 1"></span>
              <span class="el-icon-warning" v-if="Step3 && Step3.status == 2"></span>
              <span class="el-icon-mouse" v-if="Step3 && Step3.status == 3"></span>
              {{ stepStatusFormat(Step3) }}
            </div>
          </div>
          <div class="opts">
            <el-button type="primary" plain v-if="checkStepVisible(getStepName('companyDetails'))" @click="openStepModal(getStepName('companyDetails'))">
              Review
            </el-button>
          </div>
        </step-header>
        <el-card shadow="hover">
          <component :is="stepContentComp('companyDetails')" :detail="detail" :nativeRegisteredAddress="nativeRegisteredAddress" />
        </el-card>
      </div>

      <!-- Step4: 上传资料 -->
      <div class="pt40" :ref="getStepName('upload')" v-if="getStepName('upload')"></div>
      <div id="Step4" class="step mt40" v-if="getStepName('upload')">
        {{ void (Step4 = stepsTree[getStepName("upload")]) }}
        <step-header :label="getStepName('upload')">
          <div class="state mr20">
            <!-- 步骤操作日志 -->
            <el-button type="text" icon="el-icon-tickets" class="mr20" @click="openStepsHistoryModal(getStepName('upload'))">Steps History</el-button>
            <div
              class="border-type"
              :class="{
                'no-pass-button': Step4 && Step4.status == 0,
                'pass-button': Step4 && Step4.status == 1,
                'revised-button': Step4 && Step4.status == 2,
                'no-checking-button': Step4 && Step4.status == 3,
              }"
              v-if="Step4"
            >
              <span class="el-icon-error" v-if="Step4 && Step4.status == 0"></span>
              <span class="el-icon-success" v-if="Step4 && Step4.status == 1"></span>
              <span class="el-icon-warning" v-if="Step4 && Step4.status == 2"></span>
              <span class="el-icon-mouse" v-if="Step4 && Step4.status == 3"></span>
              {{ stepStatusFormat(Step4) }}
            </div>
          </div>
          <div class="opts">
            <el-button type="primary" plain v-if="checkStepVisible(getStepName('upload'))" @click="openStepModal(getStepName('upload'))">Review</el-button>
          </div>
        </step-header>
        <el-card shadow="hover">
          <component :is="materialsComp" :detail="detail" />
        </el-card>
      </div>
    </div>

    <!-- 弹窗 -->
    <step-modal ref="stepModal" v-if="stepModalVisible"></step-modal>
    <!-- 认领日志弹框 -->
    <ownership-history :applymentId="detail.id" ref="ownershipModal"></ownership-history>
    <!-- 步骤操作日志弹框 -->
    <step-history :applymentId="detail.id" ref="stepHistoryModal"></step-history>
    <!-- 状态操作日志弹框 -->
    <status-history :applymentId="detail.id" ref="statusHistoryModal"></status-history>
    <!-- 发起退款申请列表 -->
    <initiate-refund-list :detail="detail" ref="initiateRefundListModal"></initiate-refund-list>
    <!-- 退款审核 - 初审和复审 -->
    <refund-judge :detail="detail" ref="refundJudgeModal"></refund-judge>
    <!-- ACRA反馈 - 业务 -->
    <acra-feedback :detail="detail" ref="acraFeedbackModal"></acra-feedback>
    <!-- 退款信息补充 - 业务 -->
    <refund-info-update :detail="detail" ref="refundInfoUpdateModal"></refund-info-update>
    <!-- 发起终止交易申请 -->
    <termination-apply :detail="detail" ref="terminationApplyModal"></termination-apply>
    <!-- 终止交易审核 - 复核 -->
    <termination-judge :detail="detail" ref="terminationJudgeModal"></termination-judge>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import StepHeader from "../components/StepHeader";
import UserToggle from "../components/UserToggle";
import BaseInfo from "../modules/common/baseInfo";
import StepModal from "./modal/Step.vue";
import OwnershipHistory from "./modal/OwnershipHistory";
import StepHistory from "./modal/StepHistory";
import StatusHistory from "./modal/StatusHistory";
import InitiateRefundList from "./modal/InitiateRefundList/index";
import RefundJudge from "./modal/RefundJudge/index";
import AcraFeedback from "./modal/AcraFeedback";
import RefundInfoUpdate from "./modal/RefundInfoUpdate/index";
import TerminationApply from "./modal/TerminationApply";
import TerminationJudge from "./modal/TerminationJudge";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    BaseInfo,
    StepHeader,
    StepModal,
    UserToggle,
    StepHistory,
    StatusHistory,
    InitiateRefundList,
    RefundJudge,
    AcraFeedback,
    RefundInfoUpdate,
    OwnershipHistory,
    TerminationApply,
    TerminationJudge,
  },
  data() {
    return {
      stepModalVisible: false,
      affixed: false,
      riskAssessmentObj: {},
      nativeRegisteredAddress: [],
      userList: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters("constant", ["byCountryFormatList", "getApplyStepList"]),
    ...mapState("applyment", ["detail", "applymentHasNomineeDirector"]),
    ...mapState("authority", ["activeRoleName"]),
    ...mapState({
      userAt: state => {
        return { id: state.user.id, nickname: state.user.name, username: state.user.name };
      },
    }),
    stepsTree() {
      const procedures = this.detail.procedures;
      if (!procedures) {
        return {};
      }
      const r = procedures.reduce((xs, z) => {
        xs[z.step] = z;
        return xs;
      }, {});
      return r;
    },
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
    getStepName() {
      return function (val) {
        if (this.detail && this.detail.businessType && this.detail.country) {
          const item = this.byCountryFormatList("applyStepData", this.detail.country);
          return item?.[this.detail.businessType]?.[val]?.step;
        } else {
          return false;
        }
      };
    },
    visibleSteps() {
      const keys = ["companyName", "kycQuestionnaire", "companyDetails", "upload"];
      return keys.map(key => ({ key, name: this.getStepName(key) })).filter(step => step.name);
    },
    // 判断申请单是否需要名义董事
    isNeedNomineeDirector() {
      let resBool = false;
      if (this.detail.hasNomineeDirector) {
        // 勾选了(我们同意聘用由星中商务推荐的名义董事1名，我们也理解该名义董事的行为造成的任何法律影响均与EStar无关。)
        resBool = true;
      } else {
        // 没勾选(需要检查所选服务是否有“名义董事”的需求)
        // 公司设立、公司服务的转移
        if (this.detail.businessType === "COMPANY_INCORPORATION" || this.detail.businessType === "SERVICE_TRANSFER") {
          // 判断套餐或服务中是否含有名义董事
          if (this.applymentHasNomineeDirector) {
            resBool = true;
          }
        }

        // 综合性公司服务 – 定制化
        if (this.detail.businessType === "COMPREHENSIVE_CUSTOMIZED") {
          // 是否已聘用EStar提供的名义董事: 1是、0否
          if (this.detail.questionnaire && this.detail.questionnaire.appointNomineeDirector && this.detail.questionnaire.appointNomineeDirector.type) {
            resBool = true;
          }
        }
      }
      return resBool;
    },
    stepContentComp() {
      const country = this.detail.country;
      const registry = {
        Singapore: {
          companyName: () => import("../modules/singapore/StepContent_companyName"),
          kycQuestionnaire: () => import("../modules/singapore/StepContent_kycQuestionnaire"),
          companyDetails: () => import("../modules/singapore/StepContent_companyDetails"),
        },
        Malaysia: {
          companyName: () => import("../modules/malaysia/StepContent_companyName"),
          kycQuestionnaire: () => import("../modules/malaysia/StepContent_kycQuestionnaire"),
          companyDetails: () => import("../modules/malaysia/StepContent_companyDetails"),
        },
      };
      return function (stepKey) {
        return registry[country]?.[stepKey];
      };
    },
    materialsComp() {
      const country = this.detail.country;
      const registry = {
        Singapore: () => import("../modules/singapore/materials"),
        Malaysia: () => import("../modules/malaysia/materials"),
      };
      return registry[country];
    },
  },
  watch: {
    activeRoleName(newVal) {
      // 权限认领弹框
      this.getTheTask();
    },
  },
  methods: {
    ...mapActions("applyment", ["initApplyment", "doCheck", "doAudit", "doReject", "doRevise", "doAcraApply", "doClaimOwnership", "doForfeitApply"]),
    ...mapMutations("applyment", ["RESET_APPLYMENT_STATE"]),
    handleAffixChange(fixed) {
      this.affixed = fixed;
    },
    // 获取公司注册地址
    getOfficeAddressHttp() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/admin/stRegisteredOfficeAddressManage/getList`)
          .then(res => {
            const resData = res.data || [];
            // 获取申请单关联供应商id列表
            let supplierIds = [];
            const businessType = this.detail.businessType || "";
            if (businessType == "COMPREHENSIVE_CUSTOMIZED" || businessType == "FUND_ADMIN_CUSTOMIZED") {
              const quotationList = this.detail.quotationList || [];
              supplierIds = quotationList.map(ele => ele.supplier?.id).filter(v => v != null);
            } else {
              const supplierList = this.detail.supplierList || [];
              supplierIds = supplierList.map(ele => ele.id);
            }
            this.nativeRegisteredAddress = resData.filter(item => item.type == this.detail.businessGenre && supplierIds.includes(item.supplierId));
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    //步骤按钮可视
    checkStepVisible(stepName) {
      const { applymentStatus } = this.detail;
      if (this.isApplymentAuth("company:check")) {
        if (applymentStatus === "CHECKING" || applymentStatus === "REVISE_FINISH") {
          return true;
        }
      }
      if (this.isApplymentAuth("company:audit")) {
        if (applymentStatus === "AUDITING") {
          return true;
        }
      }
      if (this.isApplymentAuth("company:coordinate")) {
        if (applymentStatus === "REVISING") {
          return this.stepsTree[stepName]?.status === 2;
        }
      }
      return false;
    },
    checkStepsList() {
      let flag = 1;
      const keys = this.getApplyStepList();
      for (let i in keys) {
        let key = keys[i];
        if (!this.stepsTree[key]) {
          this.$message({
            message: key + " hadn't reviewed!",
            type: "warning",
            duration: 1000,
            onClose: () => {
              this.jumpStep(key);
            },
          });
          flag = -1;
          break;
        } else if (this.stepsTree[key].status === 2 || this.stepsTree[key].status === 3) {
          this.$message({
            message: key + " hadn't reviewed!",
            type: "warning",
            duration: 1000,
            onClose: () => {
              this.jumpStep(key);
            },
          });
          flag = -1;
          break;
        }
      }

      if (flag === 1) {
        for (let j in keys) {
          let key = keys[j];
          if (this.stepsTree[key].status === 0) {
            flag = 0;
            break;
          }
        }
      }
      return flag;
    },
    //当前步骤条状态
    getStepStatus(stepName) {
      const step = this.stepsTree[stepName];
      if (step) {
        if (step.status === undefined) {
          return "wait";
        } else {
          if (step.status === 0) {
            return "error";
          } else if (step.status === 1) {
            return "success";
          } else {
            return "process";
          }
        }
      } else {
        return "wait";
      }
    },
    //步骤锚点
    jumpStep(domId) {
      this.$refs[domId].scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    },
    // 详情
    async getDetail() {
      this.loading = true;
      try {
        await this.initApplyment(this.id);
        // 初始化基础信息组件
        await this.$nextTick();
        // 获取后台管理员列表
        await this.getSysUserList();
        // 权限认领弹框
        this.getTheTask();
        // 获取公司注册地址
        await this.getOfficeAddressHttp();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    // 获取后台管理员列表
    getSysUserList() {
      return new Promise((resolve, reject) => {
        this.$http.get("/admin/sysUser/getList").then(({ code, data, msg }) => {
          if (code === 200) {
            this.userList = data;
            resolve();
          } else {
            this.$message.error(msg);
            reject(msg);
          }
        });
      });
    },
    //弹窗逻辑
    //步骤弹窗
    async openStepModal(stepName) {
      this.stepModalVisible = true;
      await this.$nextTick();
      const stepData = this.stepsTree[stepName];
      if (stepData) {
        const copy = { ...stepData };
        this.$refs.stepModal.init(copy);
      } else {
        this.$refs.stepModal.init({
          applymentId: this.detail.id,
          step: stepName,
        });
      }
    },
    //完成初审
    async handleCheckFinish() {
      //检查风险评估表
      if (this.getStepName("kycQuestionnaire") && this.detail.isRiskAssessmentFinished !== 1) {
        // 更新detail
        await this.initApplyment(this.id);
        // 获取风险评估明细
        await this.getRiskDetailHttp();
        if (this.detail.isRiskAssessmentFinished !== 1) {
          this.$message.warning("Risk Assessment hadn't Completed!");
          return;
        }
      }

      if (this.detail.applymentStatus === "CHECKING" || this.detail.applymentStatus === "REVISE_FINISH") {
        // 检查名义董事所在的步骤是否存在
        if (
          (this.detail.businessType === "COMPANY_INCORPORATION" && this.getStepName("companyName")) ||
          (this.detail.businessType === "SERVICE_TRANSFER" && this.getStepName("kycQuestionnaire")) ||
          (this.detail.businessType === "COMPREHENSIVE_CUSTOMIZED" && this.getStepName("kycQuestionnaire"))
        ) {
          // 检查是否需要添加名义董事
          if (this.isNeedNomineeDirector) {
            // 判断是否设置了名义董事
            const idx = this.detail.companyMemberList.findIndex(element => element.positionHeld === "NOMINEE_DIRECTOR");
            if (idx === -1) {
              this.$message.warning("Nominee Director hadn't Added!");
              return;
            }
          }
        }
      }

      //检查步骤是否都已完成
      const isAllPass = this.checkStepsList();
      if (isAllPass === -1) {
        return;
      }

      this.$confirm(`Finish this checking. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        const applymentStatus = isAllPass ? "AUDITING" : "ILLEGAL";
        this.doCheck(applymentStatus)
          .then(() => {
            this.$message.success("success");
          })
          .catch(msg => {
            this.$message.error(msg);
          });
      });
    },
    //完成复核
    handleAuditFinish() {
      const isAllPass = this.checkStepsList();
      if (isAllPass === -1) {
        return;
      }

      this.$confirm(`Finish this review. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        const applymentStatus = isAllPass ? "AUDIT_SUCCESS" : "AUDIT_FAIL";
        this.doAudit(applymentStatus)
          .then(() => {
            this.$message.success("success");
          })
          .catch(msg => {
            this.$message.error(msg);
          });
      });
    },
    //资料驳回
    handleReject() {
      this.$confirm(`Reject this applyment. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        this.doReject()
          .then(() => {
            this.$message.success("success");
          })
          .catch(msg => {
            this.$message.error(msg);
          });
      });
    },
    //完成修订
    handleReviseFinish() {
      this.$confirm(`Commit this revision. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        this.doRevise()
          .then(() => {
            this.$message.success("success");
          })
          .catch(msg => {
            this.$message.error(msg);
          });
      });
    },
    // 步骤二 - 风险评估弹框
    openRiskAssessmentModal() {
      let newpage = this.$router.resolve(`/riskAssessment/${this.detail.id}`);
      window.open(newpage.href, "_blank");
    },
    // 步骤操作日志
    openStepsHistoryModal(data) {
      this.$refs.stepHistoryModal.init(data);
    },
    // 认领日志
    openOwnershipHistoryModal() {
      this.$refs.ownershipModal.init();
    },
    // 状态操作日志
    openStatusHistoryModal() {
      this.$refs.statusHistoryModal.init();
    },
    // 发起退款
    handleInitiateRefund() {
      this.$refs.initiateRefundListModal.init();
    },
    // 退款审核 - 初审 或 复核
    handleRefundJudge(type) {
      this.$refs.refundJudgeModal.init(type);
    },
    // ACRA申请 - 业务
    handleAcraApply() {
      this.doAcraApply()
        .then(() => {
          this.$message.success("success");
        })
        .catch(msg => {
          this.$message.error(msg);
        });
    },
    // ACRA反馈 - 业务
    handleAcraFeedback() {
      this.$refs.acraFeedbackModal.init();
    },
    // 退款信息补充 - 业务
    handleRefundInfoUpdate() {
      this.$refs.refundInfoUpdateModal.init();
    },
    // 下补款单 - 业务
    handleMakeAmends() {
      this.$router.push({
        path: "/quotationV",
        query: {
          applymentNo: this.detail.applymentNo,
        },
      });
    },
    // 认领
    claim(type) {
      return this.doClaimOwnership({
        ownershipRole: type,
        toUser: this.userAt,
      }).then(() => {
        this.$message.success(`${type == "auditor" ? "reviewer" : type} success`);
      });
    },
    // 权限认领弹框
    async getTheTask() {
      if (
        !this.isAuth("company:adjust") &&
        ((this.isAuth("company:coordinate") && (!this.detail.coordinator || (this.detail.coordinator && this.detail.coordinator.id === -1))) ||
          (this.isAuth("company:check") && (!this.detail.checker || (this.detail.checker && this.detail.checker.id === -1))) ||
          (this.isAuth("company:audit") && (!this.detail.auditor || (this.detail.auditor && this.detail.auditor.id === -1))))
      ) {
        let roleName = "";
        if (this.isAuth("company:coordinate") && (!this.detail.coordinator || (this.detail.coordinator && this.detail.coordinator.id === -1))) {
          roleName = "Coordinator";
        } else if (this.isAuth("company:check") && (!this.detail.checker || (this.detail.checker && this.detail.checker.id === -1))) {
          roleName = "Checker";
        } else if (this.isAuth("company:audit") && (!this.detail.auditor || (this.detail.auditor && this.detail.auditor.id === -1))) {
          roleName = "Reviewer";
        }
        await this.$confirm("Whether to pick up the work task of the application?", `Tasks Of ${roleName}`, {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "info",
        });
        if (this.isAuth("company:coordinate") && (!this.detail.coordinator || (this.detail.coordinator && this.detail.coordinator.id === -1))) {
          await this.claim("coordinator");
        }
        if (this.isAuth("company:check") && (!this.detail.checker || (this.detail.checker && this.detail.checker.id === -1))) {
          await this.claim("checker");
        }
        if (this.isAuth("company:audit") && (!this.detail.auditor || (this.detail.auditor && this.detail.auditor.id === -1))) {
          await this.claim("auditor");
        }
      }
    },
    // 获取风险评估明细
    getRiskDetailHttp() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/companyApplymentRiskAssessment/detail", {
            params: {
              applymentId: this.id,
            },
          })
          .then(({ code, data, msg }) => {
            if (code === 200) {
              this.riskAssessmentObj = data && data.content ? data.content : {};
              resolve();
            } else {
              this.$message.error(msg);
              reject(msg);
            }
          });
      });
    },
    // 申请终止交易 - 业务
    handleTerminationApply() {
      this.$refs.terminationApplyModal.init();
    },
    // 申请终止交易 - 复核
    handleAuditTerminated() {
      this.$refs.terminationJudgeModal.init();
    },
    // 废弃申请 - 业务、复核
    async handleForfeitApply() {
      await this.$confirm("Forfeit this application. Continue?", "Warning", {
        confirmButtonText: "OK",
        confirmButtonClass: "confirm-default-button",
        cancelButtonText: "Cancel",
        cancelButtonClass: "confirm-blue-button",
        type: "warning",
      });
      this.doForfeitApply()
        .then(() => {
          this.$message({
            message: "success",
            type: "success",
            duration: 1500,
            onClose: () => {},
          });
        })
        .catch(msg => {
          this.$message.error(msg);
        });
    },
  },
  activated() {
    // 先重置申请单详情(避免展示旧数据)
    this.RESET_APPLYMENT_STATE();
    // 请求申请单详情
    this.id = this.$route.params.id;
    this.getDetail();
    // 获取风险评估明细
    this.getRiskDetailHttp();
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variables.scss";

.company-applyment-module {
  .applyment-page-header {
    background-color: #fff;
    // padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .page-header-heading-left {
      display: none;
    }

    .page-header-heading-content {
      width: 620px;
      padding-top: 12px;
    }

    .page-header-heading-right {
      .opts {
        display: inline-block;
      }
    }

    .status {
      display: inline-block;
      font-size: 20px;
      font-weight: bold;
      margin-right: 20px;
      color: #12a3ff;
      .fs12 {
        font-size: 12px;
      }
    }

    .status::before {
      display: inline-block;
      content: "";
      background: #12a3ff;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      vertical-align: middle;
      margin-right: 4px;
      margin-top: -4px;
    }
  }
  .applyment-page-header-top {
    .affix {
      z-index: 1030 !important;
    }
    .page-header-heading-left {
      display: inline-block;
    }
    .page-header-heading-content {
      display: none;
    }
    .status-label {
      display: none;
    }
  }

  .applyment-page-header-shrink {
    .affix {
      left: $sidebar-width !important;
      width: calc(100% - #{$sidebar-width} - 18px) !important;
    }
  }

  .applyment-page-header-unfold {
    .affix {
      left: $sidebar-full-width !important;
      width: calc(100% - #{$sidebar-full-width} - 18px) !important;
    }
  }

  .steps-bar-wrapper {
    position: fixed;
    right: 6px;
    top: 38vh;
    z-index: 1000;
  }

  .desp {
    color: rgb(53, 55, 68);

    .desp-header {
      font-size: 18px;
      padding: 10px 5px 10px;
      border-bottom: 1px solid #ebeef0;
      margin-bottom: 15px;
      color: #011a45;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
    }

    .desp-items-group {
      & + .desp-items-group {
        margin-top: 24px;
      }
    }

    .desp-items-group-title {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      border-left: 3px solid #eee;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-title-icon {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      color: #0060ff;
      // border-left: 3px solid #eee;
      background: #eceff9;
      margin-bottom: 15px;

      .title {
        font-weight: bold;
        font-size: 16px;
      }
    }

    .desp-item {
      overflow: hidden;
    }

    .desp-item-label {
      width: 166px;
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #667288;
      line-height: 40px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
    }

    .desp-item-label:after {
      content: ":";
      position: relative;
      top: -0.5px;
      margin: 0 8px 0 2px;
    }

    .desp-item-content {
      margin-left: 100px;
      line-height: 40px;
      position: relative;
      font-size: 14px;
      color: #011a45;
    }

    .desp-item-self {
      width: 100%;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0 12px 0;
      box-sizing: border-box;
    }

    .desp-item-form {
      width: 100%;
      vertical-align: middle;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0;
      box-sizing: border-box;
    }
  }
}

.border-type {
  display: inline-block;
  padding: 10px 20px;
  line-height: 1em;
  border-radius: 4px;
}

.pass-button {
  border: 1px solid $--color-success;
  background: #e0fff6;
  color: $--color-success;
}

.no-pass-button {
  border: 1px solid $--color-danger;
  background: #ffe4e4;
  color: $--color-danger;
}

.revised-button {
  border: 1px solid $--color-warning;
  background: #fff0e8;
  color: $--color-warning;
}

.no-checking-button {
  border: 1px solid $navbar--color-dark;
  background: transparent;
  color: $navbar--color-dark;
}

.confirm-default-button {
  border: 1px solid #dcdfe6 !important;
  background-color: #fff !important;
  color: #606266 !important;
}

.confirm-blue-button {
  border: 1px solid #338eff !important;
  background-color: #338eff !important;
  color: #fff !important;
}
</style>
